/**
 * Minimal gallery helpers for NeighborhoodSection.
 * Full mosaic/lightbox utilities remain in the parent theme's PhotoGallery.
 */

export interface GalleryImage {
  image?: string | null;
  alt_text?: string | null;
  title?: string | null;
  description?: string | null;
  source_page_urls?: string | null;
  original_url?: string | null;
}

/** Classify a gallery photo by its title — used to split community vs unit shots. */
export function classifyPhoto(photo: GalleryImage): 'apartment' | 'community' | 'lifestyle' | 'other' {
  const title = (photo.title || '').toLowerCase().trim();
  if (title.includes('apartment')) return 'apartment';
  if (title.includes('community')) return 'community';
  if (title.includes('lifestyle')) return 'lifestyle';
  return 'other';
}
